import { CottageVillageContainer } from '../../containers/filters/CottageVillageContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const cottageVillage: IOpenableFilter = {
  component: CottageVillageContainer,
  type: EFilterType.Openable,
};
